import { PropTypes } from 'prop-types';
import { userDataPropTypes, userSerialiser } from './user';

export const qualityAssuranceSerialiser = (qualityAssuranceInfo) => ({
  approvedBy: userSerialiser(qualityAssuranceInfo?.approved_by),
  deletedBy: userSerialiser(qualityAssuranceInfo?.deleted_by),
  rejectedBy: userSerialiser(qualityAssuranceInfo?.rejected_by),
  uploadedBy: userSerialiser(qualityAssuranceInfo?.uploaded_by),
});

export const qaDataPropTypes = {
  approvedBy: PropTypes.shape(userDataPropTypes),
  deletedBy: PropTypes.shape(userDataPropTypes),
  rejectedBy: PropTypes.shape(userDataPropTypes),
  uploadedBy: PropTypes.shape(userDataPropTypes),
};
